export default class ArsaDegerFilter {
    constructor(
        public yil: number,
        private mahalleId: string) { }
}